import { AVATAR_SIZES } from './constants.js';
import { type AvatarSize } from './types.js';

export const getAvatarSize = (size: AvatarSize): number => {
  if (typeof size === 'number') return size;

  return AVATAR_SIZES[size];
};
